import React, { useRef, useState } from "react"


export default function RbaChoice(props) {

const optionStyleTrue = {
    width: "90%",
    border: "1px solid #292929",
    margin: "10px auto 0 auto",
    color: "#292929",
    padding: "14px 8px",
    borderRadius: "5px",
    fontSize: "14px",
    fontWeight: "400",
    background: "#f1f1f1",
    display: "flex",
    justifyContent: "space-between",
    cursor: "pointer",
  }

  const optionStyleFalse = {
    width: "90%",
    border: "1px solid #bbb",
    margin: "10px auto 0 auto",
    color: "#888",
    padding: "14px 8px",
    borderRadius: "5px",
    fontSize: "14px",
    fontWeight: "400",
    background: "#FFF",
    display: "flex",
    justifyContent: "space-between",
    cursor: "pointer",
  }

  let nameStyle = {
    margin: '0',
  }


    return (
      <>   
        <div
          style={{
            position: "relative",
            width: "100%",
            maxWidth: "640px",
            paddingTop: "56.25%", // 16:9 aspect ratio
            margin: "0 auto",
            
          }}
        >
          <iframe
            src={props.videosList.rba}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              border: "none",
              
            }}
            title="Risks, benefits, and alternatives"
            allowFullScreen
          />
        </div>            


        {/* Lens options */}

            <>
              <div
                style={!props.acknowledgeRba ? optionStyleTrue : optionStyleFalse}
                onClick={() => {
                  props.setAcknowledgeRba(false)
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '100%',
                  }}
                >
                  <p style={nameStyle}> 
                    {props.spanish === true ? 'No acepto los riesgos de la cirugía' : 'I do not accept the risks of surgery'}
                  </p>
         
                </div>
              </div>

              <div
                style={props.acknowledgeRba ? optionStyleTrue : optionStyleFalse}
                onClick={() => {
                  props.setAcknowledgeRba(true)
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '100%',
                  }}
                >
                  <p style={nameStyle}> 
                    {props.spanish === true ? 'Entiendo y acepto los riesgos de la cirugía' : 'I understand and accept the risks of surgery'}
                  </p>
         
                </div>
              </div>
            </>
      </>
    )
 
}